import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=b02c138c&scoped=true&"
import script from "./ProductSlider.vue?vue&type=script&lang=ts&"
export * from "./ProductSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=b02c138c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02c138c",
  null
  
)

export default component.exports